import React from 'react';
import Slider from '@mui/material/Slider';
import Grid from '@mui/material/Grid';
import { rectangleStyle } from '../LikertResponse/LikertResponse'

const sliderStyle = {
    '& input[type="range"]': {
        WebkitAppearance: 'slider-vertical',
    },
        color: '#B2292D',
        width: '100%',
        height: 100,
        margin: 0,
    '& .MuiSlider-track': {
        border: 'none',
        borderRadius: 0,
        color: '#B2292D'
    },
    '& .MuiSlider-rail': {
        borderRadius: 0,
        color: "#5B6586", 
        opacity: 1
    },
    '& .MuiSlider-thumb': {
        height: 24,
        width: 24,
        backgroundColor: '#fff',
        border: '2px solid currentColor',
    },
    '& .MuiSlider-valueLabel': {
        backgroundColor: '#B2292D',
        fontSize: '14pt',
    },
    '& .MuiSlider-markLabel': {
        padding: '80px 0',
        fontSize: '14pt',
    },
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center'
}

function LikertAnswer(props) {
    const scale = props.answer[0].percent + props.answer[1].percent 
    const totalPercents = scale + props.answer[2].percent
    const sliderWidthPercentage = 100 * scale / totalPercents
    const greyRecWidthPercentage = 100 - sliderWidthPercentage

    return (
        <div className="likert-answer-container">
            <Grid container direction="row" justifyContent="center" alignItems="center" >
                <Grid item width={`${sliderWidthPercentage}%`}>
                    <Slider
                        sx={sliderStyle}
                        orientation="horizontal"
                        aria-label="likert-2-sides"
                        valueLabelDisplay="off"
                        defaultValue={props.answer[0].percent} 
                        valueLabelFormat={value => <p>{value}%</p> }
                        disabled={true}
                        max={scale}
                    />  
                </Grid>
                <Grid item width={`${greyRecWidthPercentage}%`} justifyContent='center' display='flex' alignItems='center' >
                    <div style={rectangleStyle}></div>
                </Grid>
            </Grid>
        </div>
    );
}

export default LikertAnswer;
